import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { Player } from "./Player";

export class Shadow extends GameObject {

	scene: GameScene;
	player: Player;

	constructor(scene: GameScene) {
		super(scene);
		this.addImage("playerShadow");
		this.scale = 0.5;
	}

	physicsUpdate(dt: number): void {
		super.update(dt);

		this.x = this.player.x;
		this.y = 1080 - 80;

		const dist = Math.abs(this.player.y - this.y);
		const scale = 0.6 + dist * 0.0003;
		this.scale = scale;
		this.alpha = Phaser.Math.Clamp(1 - dist * 0.001, 0, 1);
	}

}